import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
const NewNotificationIcon = React.memo((props) => {
    return (_jsx(SvgIcon, { ...props, children: _jsx("svg", { fill: "none", children: _jsx("circle", { cx: "6", cy: "6", r: "6", fill: "#FF2D55" }) }) }));
});
export { NewNotificationIcon };
//# sourceMappingURL=NewNotificationIcon.js.map